const cfg:Conifg = {
  baseUrl: `${window.location.origin}/api`,
  showIcp: false
}

export default cfg